import React from "react";

export type Severity = "critical" | "high" | "medium" | "low" | "info";

export function normalizeSeverity(severity: string | null | undefined): Severity {
  const sev = String(severity || "").toLowerCase();
  if (sev === "critical" || sev === "high" || sev === "medium" || sev === "low" || sev === "info") {
    return sev;
  }
  return "info";
}

export default function SeverityBadge({ severity }: { severity: string }) {
  const sev = normalizeSeverity(severity);

  const config: Record<Severity, { bg: string; text: string; dot: string }> = {
    critical: { bg: "bg-critical/20", text: "text-critical", dot: "bg-critical" },
    high: { bg: "bg-high/20", text: "text-high", dot: "bg-high" },
    medium: { bg: "bg-medium/20", text: "text-medium", dot: "bg-medium" },
    low: { bg: "bg-low/20", text: "text-low", dot: "bg-low" },
    info: { bg: "bg-info/20", text: "text-info", dot: "bg-info" },
  };

  const c = config[sev];
  const label = sev.charAt(0).toUpperCase() + sev.slice(1);

  return (
    <div className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-lg ${c.bg}`}>
      <span className={`w-2 h-2 rounded-full ${c.dot} ${sev === "critical" ? "animate-pulse" : ""}`} />
      <span className={`text-xs font-semibold uppercase ${c.text}`}>{label}</span>
    </div>
  );
}
